import React from 'react';

import {TFunction} from 'i18next';

import {ProductGroupIcon} from 'components/common/ProductGroupIcon';
import {breakpoint} from 'theme';
import {ProductsUPDAccessors, ProductsUPDItem} from 'types/documents';
import {useMatchMedia} from 'utils/custom-hooks';
import {handleNil} from 'utils/handleNil';

import {ProductsList} from './List';
import {ProductsTable} from './Table';

const getConfig = (t: TFunction) => [
    {
        Header: t('pages.products.grid.productGroup'),
        accessor: ProductsUPDAccessors.productGroupCode,
        disableSortBy: true,
        width: 150,
    },
    {
        Header: t('pages.products.grid.gtin'),
        accessor: ProductsUPDAccessors.gtin,
        disableSortBy: true,
        width: 260,
    },
    {
        Header: t('pages.products.grid.productName'),
        accessor: ProductsUPDAccessors.productName,
        disableSortBy: true,
        width: 200,
    },
    {
        Header: t('pages.products.grid.quantity'),
        accessor: ProductsUPDAccessors.quantity,
        disableSortBy: true,
        width: 150,
    },
];

export function convertData(data: ProductsUPDItem[] | undefined, t: TFunction): ProductsUPDItem[] {
    if (!data || !data.length) {
        return [];
    }
    return data.map((elem) => ({
        [ProductsUPDAccessors.productName]: handleNil(elem.productName),
        [ProductsUPDAccessors.productGroupCode]: handleNil(elem.productGroupCode, (value) => (
            <ProductGroupIcon value={value} label />
        )),
        [ProductsUPDAccessors.gtin]: handleNil(elem.gtin),
        [ProductsUPDAccessors.quantity]: handleNil(elem.quantity),
    }));
}

interface Props {
    reportId: string;
}

export const UPDProducts = ({reportId}: Props) => {
    const isMobile = useMatchMedia(`(max-width: ${breakpoint.phone})`);

    return (
        <>
            {!isMobile && (
                <ProductsTable
                    reportId={reportId}
                    configFunc={getConfig}
                    dataMapper={convertData}
                />
            )}
            {isMobile && (
                <ProductsList reportId={reportId} configFunc={getConfig} dataMapper={convertData} />
            )}
        </>
    );
};
